import m from "isomorphic-unfetch";
import E from "form-data";
import { createMachine as D, assign as i, spawn as U, send as f, actions as L } from "xstate";
const T = (r) => {
  try {
    return btoa(r), r;
  } catch {
    return encodeURIComponent(r);
  }
}, y = async (r, e, {
  accessToken: t,
  name: s,
  fileId: o,
  bucketId: u,
  adminSecret: n,
  onUploadProgress: d
} = {}) => {
  const l = {};
  o && (l["x-nhost-file-id"] = o), u && (l["x-nhost-bucket-id"] = u), s && (l["x-nhost-file-name"] = T(s)), n && (l["x-hasura-admin-secret"] = n), t && (l.Authorization = `Bearer ${t}`);
  const p = `${r}/files`;
  if (typeof XMLHttpRequest > "u")
    try {
      const c = await m(p, {
        method: "POST",
        headers: l,
        body: e
      });
      return c.ok ? { fileMetadata: await c.json(), error: null } : { error: {
        status: c.status,
        message: await c.text(),
        error: c.statusText
      }, fileMetadata: null };
    } catch (c) {
      return { error: {
        status: 0,
        message: c.message,
        error: c.message
      }, fileMetadata: null };
    }
  return new Promise((c) => {
    let a = new XMLHttpRequest();
    a.responseType = "json", a.onload = () => a.status < 200 && a.status >= 300 ? c({
      fileMetadata: null,
      error: { error: a.statusText, message: a.statusText, status: a.status }
    }) : c({ fileMetadata: a.response, error: null }), a.onerror = () => c({
      fileMetadata: null,
      error: { error: a.statusText, message: a.statusText, status: a.status }
    }), d && a.upload.addEventListener("progress", d, !1), a.open("POST", p, !0), Object.entries(l).forEach(([P, O]) => {
      a.setRequestHeader(P, O);
    }), a.send(e);
  });
};
class S {
  constructor({ url: e }) {
    this.url = e;
  }
  async upload(e) {
    const { formData: t } = e;
    return y(this.url, t, {
      accessToken: this.accessToken,
      adminSecret: this.adminSecret,
      bucketId: e.bucketId,
      fileId: e.id,
      name: e.name
    });
  }
  async getPresignedUrl(e) {
    try {
      const { fileId: t } = e, s = await m(`${this.url}/files/${t}/presignedurl`, {
        method: "GET",
        headers: this.generateAuthHeaders()
      });
      if (!s.ok)
        throw new Error(await s.text());
      return { presignedUrl: await s.json(), error: null };
    } catch (t) {
      return { presignedUrl: null, error: t };
    }
  }
  async delete(e) {
    try {
      const { fileId: t } = e, s = await m(`${this.url}/files/${t}`, {
        method: "DELETE",
        headers: this.generateAuthHeaders()
      });
      if (!s.ok)
        throw new Error(await s.text());
      return { error: null };
    } catch (t) {
      return { error: t };
    }
  }
  setAccessToken(e) {
    return this.accessToken = e, this;
  }
  setAdminSecret(e) {
    return this.adminSecret = e, this;
  }
  generateAuthHeaders() {
    if (!(!this.adminSecret && !this.accessToken))
      return this.adminSecret ? {
        "x-hasura-admin-secret": this.adminSecret
      } : {
        Authorization: `Bearer ${this.accessToken}`
      };
  }
}
const R = (r, e) => {
  const t = Object.entries(e).map(([s, o]) => `${s.charAt(0)}=${o}`).join("&");
  return t ? `${r}?${t}` : r;
};
class k {
  constructor({ url: e, adminSecret: t }) {
    this.url = e, this.api = new S({ url: e }), this.setAdminSecret(t);
  }
  async upload(e) {
    let t;
    return "file" in e ? (t = new E(), t.append("file", e.file)) : t = e.formData, this.api.upload({
      ...e,
      formData: t
    });
  }
  getPublicUrl(e) {
    const { fileId: t, ...s } = e;
    return R(
      `${this.url}/files/${t}`,
      s
    );
  }
  async getPresignedUrl(e) {
    const { presignedUrl: t, error: s } = await this.api.getPresignedUrl(e);
    return s ? { presignedUrl: null, error: s } : t ? { presignedUrl: t, error: null } : { presignedUrl: null, error: new Error("Invalid file id") };
  }
  async delete(e) {
    const { error: t } = await this.api.delete(e);
    return t ? { error: t } : { error: null };
  }
  setAccessToken(e) {
    return this.api.setAccessToken(e), this;
  }
  setAdminSecret(e) {
    return this.api.setAdminSecret(e), this;
  }
}
const A = {
  progress: null,
  loaded: 0,
  error: null,
  bucketId: void 0,
  file: void 0,
  id: void 0
}, _ = () => D(
  {
    predictableActionArguments: !0,
    schema: {
      context: {},
      events: {}
    },
    tsTypes: {},
    context: { ...A },
    initial: "idle",
    on: {
      DESTROY: { actions: "sendDestroy", target: "stopped" }
    },
    states: {
      idle: {
        on: {
          ADD: { actions: "addFile" },
          UPLOAD: { cond: "hasFile", target: "uploading" }
        }
      },
      uploading: {
        entry: "resetProgress",
        on: {
          UPLOAD_PROGRESS: { actions: ["incrementProgress", "sendProgress"] },
          UPLOAD_DONE: "uploaded",
          UPLOAD_ERROR: "error",
          CANCEL: "idle"
        },
        invoke: { src: "uploadFile" }
      },
      uploaded: {
        entry: ["setFileMetadata", "sendDone"],
        on: {
          ADD: { actions: "addFile", target: "idle" },
          UPLOAD: { actions: "resetContext", target: "uploading" }
        }
      },
      error: {
        entry: ["setError", "sendError"],
        on: {
          ADD: { actions: "addFile", target: "idle" },
          UPLOAD: { actions: "resetContext", target: "uploading" }
        }
      },
      stopped: { type: "final" }
    }
  },
  {
    guards: {
      hasFile: (r, e) => !!r.file || !!e.file
    },
    actions: {
      incrementProgress: i({
        loaded: (r, { loaded: e }) => e,
        progress: (r, { progress: e }) => e
      }),
      setFileMetadata: i({
        id: (r, { id: e }) => e,
        bucketId: (r, { bucketId: e }) => e,
        progress: (r) => 100
      }),
      setError: i({ error: (r, { error: e }) => e }),
      sendProgress: () => {
      },
      sendError: () => {
      },
      sendDestroy: () => {
      },
      sendDone: () => {
      },
      resetProgress: i({ progress: (r) => null, loaded: (r) => 0 }),
      resetContext: i((r) => A),
      addFile: i({
        file: (r, { file: e }) => e,
        bucketId: (r, { bucketId: e }) => e,
        id: (r, { id: e }) => e
      })
    },
    services: {
      uploadFile: (r, e) => (t) => {
        const s = e.file || r.file, o = new E();
        o.append("file", s);
        let u = 0;
        return y(e.url, o, {
          fileId: e.id || r.id,
          bucketId: e.bucketId || r.bucketId,
          accessToken: e.accessToken,
          adminSecret: e.adminSecret,
          name: e.name || s.name,
          onUploadProgress: (n) => {
            const d = n.total ? Math.round(n.loaded * s.size / n.total) : 0, l = d - u;
            u = d, t({
              type: "UPLOAD_PROGRESS",
              progress: n.total ? Math.round(d * 100 / n.total) : 0,
              loaded: d,
              additions: l
            });
          }
        }).then(({ fileMetadata: n, error: d }) => {
          if (d && t({ type: "UPLOAD_ERROR", error: d }), n) {
            const { id: l, bucketId: p } = n;
            t({ type: "UPLOAD_DONE", id: l, bucketId: p });
          }
        }), () => {
        };
      }
    }
  }
), { pure: g, sendParent: h } = L, M = () => D(
  {
    id: "files-list",
    schema: {
      context: {},
      events: {}
    },
    tsTypes: {},
    predictableActionArguments: !0,
    context: {
      progress: null,
      files: [],
      loaded: 0,
      total: 0
    },
    initial: "idle",
    on: {
      UPLOAD: { cond: "hasFileToDownload", actions: "addItem", target: "uploading" },
      ADD: { actions: "addItem" },
      REMOVE: { actions: "removeItem" }
    },
    states: {
      idle: {
        entry: ["resetProgress", "resetLoaded", "resetTotal"],
        on: {
          CLEAR: { actions: "clearList", target: "idle" }
        }
      },
      uploading: {
        entry: ["upload", "startProgress", "resetLoaded", "resetTotal"],
        on: {
          UPLOAD_PROGRESS: { actions: ["incrementProgress"] },
          UPLOAD_DONE: [
            { cond: "isAllUploaded", target: "uploaded" },
            { cond: "isAllUploadedOrError", target: "error" }
          ],
          UPLOAD_ERROR: [
            { cond: "isAllUploaded", target: "uploaded" },
            { cond: "isAllUploadedOrError", target: "error" }
          ],
          CANCEL: { actions: "cancel", target: "idle" }
        }
      },
      uploaded: {
        entry: "setUploaded",
        on: {
          CLEAR: { actions: "clearList", target: "idle" }
        }
      },
      error: {
        on: {
          CLEAR: { actions: "clearList", target: "idle" }
        }
      }
    }
  },
  {
    guards: {
      hasFileToDownload: (r, e) => r.files.some((t) => t.getSnapshot().matches("idle")) || !!e.files,
      isAllUploaded: (r) => r.files.every((e) => {
        var t;
        return (t = e.getSnapshot()) == null ? void 0 : t.matches("uploaded");
      }),
      isAllUploadedOrError: (r) => r.files.every((e) => {
        const t = e.getSnapshot();
        return (t == null ? void 0 : t.matches("error")) || (t == null ? void 0 : t.matches("uploaded"));
      })
    },
    actions: {
      incrementProgress: i((r, e) => {
        const t = r.loaded + e.additions, s = Math.round(t * 100 / r.total);
        return { ...r, loaded: t, progress: s };
      }),
      setUploaded: i({
        progress: (r) => 100,
        loaded: ({ files: r }) => r.map((e) => e.getSnapshot()).filter((e) => e.matches("uploaded")).reduce((e, t) => {
          var s;
          return e + ((s = t.context.file) == null ? void 0 : s.size);
        }, 0)
      }),
      resetTotal: i({
        total: ({ files: r }) => r.map((e) => e.getSnapshot()).filter((e) => !e.matches("uploaded")).reduce((e, t) => {
          var s;
          return e + ((s = t.context.file) == null ? void 0 : s.size);
        }, 0)
      }),
      resetLoaded: i({ loaded: (r) => 0 }),
      startProgress: i({ progress: (r) => 0 }),
      resetProgress: i({ progress: (r) => null }),
      addItem: i((r, { files: e, bucketId: t }) => {
        const s = e ? Array.isArray(e) ? e : "item" in e ? Array.from(e) : [e] : [], o = r.total + s.reduce((n, d) => n + d.size, 0), u = Math.round(r.loaded * 100 / o);
        return {
          files: [
            ...r.files,
            ...s.map(
              (n) => U(
                _().withConfig({
                  actions: {
                    sendProgress: h((d, { additions: l }) => ({
                      type: "UPLOAD_PROGRESS",
                      additions: l
                    })),
                    sendDone: h("UPLOAD_DONE"),
                    sendError: h("UPLOAD_ERROR"),
                    sendDestroy: h("REMOVE")
                  }
                }).withContext({ ...A, file: n, bucketId: t }),
                { sync: !0 }
              )
            )
          ],
          total: o,
          loaded: r.loaded,
          progress: u
        };
      }),
      removeItem: i({
        files: (r) => r.files.filter((e) => {
          var s, o;
          const t = (s = e.getSnapshot()) == null ? void 0 : s.matches("stopped");
          return t && ((o = e.stop) == null || o.call(e)), !t;
        })
      }),
      clearList: g(
        (r) => r.files.map((e) => f({ type: "DESTROY" }, { to: e.id }))
      ),
      upload: g((r, e) => r.files.map((t) => f(e, { to: t.id }))),
      cancel: g(
        (r) => r.files.map((e) => f({ type: "CANCEL" }, { to: e.id }))
      )
    }
  }
), F = async (r, e) => new Promise((t) => {
  e.send({
    type: "UPLOAD",
    ...r
  }), e.subscribe((s) => {
    var o;
    s.matches("error") ? t({
      error: s.context.error,
      isError: !0,
      isUploaded: !1
    }) : s.matches("uploaded") && t({
      error: null,
      isError: !1,
      isUploaded: !0,
      id: s.context.id,
      bucketId: s.context.id,
      name: (o = s.context.file) == null ? void 0 : o.name
    });
  });
}), b = async (r, e) => new Promise((t) => {
  e.send({
    type: "UPLOAD",
    ...r,
    files: r.files
  }), e.onTransition((s) => {
    s.matches("error") ? t({
      errors: s.context.files.filter((o) => {
        var u;
        return (u = o.getSnapshot()) == null ? void 0 : u.context.error;
      }),
      isError: !0,
      files: []
    }) : s.matches("uploaded") && t({ errors: [], isError: !1, files: s.context.files });
  });
});
export {
  S as HasuraStorageApi,
  k as HasuraStorageClient,
  A as INITIAL_FILE_CONTEXT,
  R as appendImageTransformationParameters,
  _ as createFileUploadMachine,
  M as createMultipleFilesUploadMachine,
  F as uploadFilePromise,
  b as uploadMultipleFilesPromise
};
//# sourceMappingURL=index.esm.js.map
